<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Select your mining algorithm
  .column.mb-20
    .columns.is-multiline
      .column(v-for="o in filteredAlgos", v-if="!o.deactivated")
        .box-container
          .element-box-container(@click="select(o)")
            span.name {{ o.name }}
            br
            .is-flex.jcc.aic
              .algo-image
                img(:src="o.symbolLogo", :alt="o.symbol + ' logo'")
              .symbol-container
                span {{ o.symbol }} based
                span.minimun(v-if="o.minimumVramRequirement") > {{ o.minimumVramRequirement }} GPU
  
  .feature-helvetica.step-explanation
    div.mb-10
      span Be sure to meet the minimum hardware requirements (VRAM memory size) for the algorithm that you select.
      
    .articles
      router-link.article-mini(to="/support/article/what-are-the-minimum-requirements-for-mining", target="_blank")
        .article-inner
          .article-title
            span  What are the minimum requirements for mining?
          span.icon
            i.fa.fa-external-link

</template>

<script>
export default {
  name: 'c_step_algorithm',
  props: ['miningType'],
  data () {
    return {
    }
  },
  computed: {
    algos () {
      return this.$store.getters.algos
    },
    filteredAlgos () {
      let vm = this
      let algorithms = vm.algos.filter(o => o.typeCode === vm.miningType)
      algorithms.sort((a, b) => {
        return a.wizardSort - b.wizardSort;
      });
      return algorithms
    }
  },
  created () {
    let vm = this
    if (vm.filteredAlgos.length === 1) {
      vm.$emit('selected', vm.filteredAlgos[0], true)
    }
  },
  mounted () {
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    select (algo) {
      let vm = this
      vm.$emit('selected', algo, false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.gs 
  .column
    padding 5px
    min-width: 152px;
  .box-container
    margin-top 10px
    .element-box-container
      margin 0
      padding 15px !important
      .name
        text-align center
        font-weight 400
        font-size 20px
      .symbol-container
        display flex
        flex-direction column 
        justify-content center
        font-size: 10px;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 1px;
        color: #878787;
        text-align left
      .algo-image
        margin: 2px 5px;
        padding-top 3px
        width: 25px;
        min-width: 25px;

html.dark, body.dark
  .symbol-container
    color #c0c0c0 !important

@media (max-width: 1279px)
  .miner
    .button-down-container
      .button-down
        width 49%
        &.is-info
          width 100%

</style>



// WEBPACK FOOTER //
// c_step_algorithm.vue?40c2a60b